(function($){
$(document).ready(function() {

    if ( $('.popinmessage').html() != undefined && $('.popinmessage').html().trim() != '' ) {
        $.popin.alert( {
            type: $('.popinmessage').data('type'),
            title: $('.popinmessage').data('title'),
            message: $('.popinmessage').html(),
            button: $('.popinmessage').data('button')
        });
    }

})
})(jQuery);
